<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- =============================== -->
        <v-row>
            <v-col>
                <h2 class="my-2">通知設定</h2>
            </v-col>
            <v-col class="text-right mt-3">
                <v-btn small color="success" @click="editItemDialog(null)"><h3>追加</h3></v-btn>
            </v-col>
        </v-row>
        <!-- =============================== -->
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="item in dbNotificationConfigs" :key="item.id">
                <v-card>
                    <v-toolbar color="indigo" dark>
                        <v-toolbar-title class="font-weight-bold">{{ item.device_name }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <div v-show="!['water', 'temp', 'oxygen', 'solar', 'salinity', 'current', 'turbidity'].includes(item.alert_fld)">
                            <h3>監視項目：{{ item.alert_name }}</h3>
                        </div>
                        <div v-show="['water', 'temp', 'oxygen', 'solar', 'salinity', 'current', 'turbidity'].includes(item.alert_fld)">
                            <h3>監視項目：{{ item.alert_name }} {{ item.upper_lower == "upper" ? "上限" : "下限" }} {{ item.limit_val }}</h3>
                            <h5>（{{ item.alert_name }} が {{ item.limit_val }} {{ item.upper_lower == "upper" ? "以上" : "以下" }} となった場合にメールを送信します。）</h5>
                        </div>
                        <v-divider class="my-3"></v-divider>
                        <h4 v-show="dbUser.email">通知先アドレス：{{ dbUser.email }}</h4>
                        <h4 v-show="!dbUser.email" class="red--text">通知先アドレス：未設定</h4>
                        <v-divider class="my-3"></v-divider>
                        <h4>メモ：{{ item.memo }}</h4>
                        <v-divider class="my-3"></v-divider>
                        <h4>前回通知日時：{{ item.sent_at }}</h4>
                        <v-divider class="my-3"></v-divider>
                        <h4>再通知： {{ silenceText(item.silence_minutes) }} 後</h4>
                        <h5>（前回通知から{{ silenceText(item.silence_minutes) }}は監視を一時停止します。）</h5>
                        <!--
                        <v-divider class="my-3"></v-divider>
                        <v-btn color="blue darken-2" text @click="deleteItemConfirmDialog(item)" class="pa-0"><v-icon>mdi-delete</v-icon>通知設定削除</v-btn>
                        -->
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small color="success" @click="editItemDialog(item)"><h3>編集</h3></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- =============================== -->
        <v-dialog v-model="showEditDlg" fullscreen transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar color="indigo" dark>
                    <v-toolbar-title>通知設定</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showEditDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="12">
                            <v-select label="デバイス" outlined v-model="editedItem.device_id" :items="deviceOptions" :rules="[rules.required]" hide-details></v-select>
                        </v-col>
                        <v-col cols="10">
                            <v-select label="監視項目" outlined v-model="editedItem.alert_fld" :items="alertOptions" :rules="[rules.required]" hide-details></v-select>
                        </v-col>
                        <v-col cols="5" v-show="['water', 'temp', 'oxygen', 'solar', 'salinity', 'current', 'turbidity'].includes(editedItem.alert_fld)">
                            <v-select label="上限/下限" outlined v-model="editedItem.upper_lower" :items="upperLowerOptions" :rules="[rules.required]" hide-details></v-select>
                        </v-col>
                        <v-col cols="5" v-show="['water', 'temp', 'oxygen', 'solar', 'salinity', 'current', 'turbidity'].includes(editedItem.alert_fld)">
                            <v-text-field label="しきい値" outlined v-model="editedItem.limit_val" type="number" step="0.1" :rules="[rules.required]" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="メールアドレス" outlined v-model="dbUser.email" hide-details disabled></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select label="再通知" outlined v-model="editedItem.silence_minutes" :items="silenceOptions" :rules="[rules.required]" hide-details></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field outlined v-model="editedItem.memo" label="メモ" hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="showDelDlg = true" v-show="editedItem.id" width="100">削除</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" outlined @click="showEditDlg = false" width="100">キャンセル</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="submitItem(editedItem)" width="100">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <v-divider></v-divider>
                <div class="pa-3"></div>
            </v-card>
        </v-dialog>
        <!-- =============================== -->
        <v-dialog v-model="showDelDlg" max-width="500px">
            <v-card>
                <v-toolbar color="indigo" dark><h3>確認</h3></v-toolbar>
                <v-card-text class="py-5">
                    <h2>「{{ editedItem.alert_name }}」</h2>
                    <h4>の通知を削除しますか?</h4>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="error" @click="submitDeleteItem(editedItem)" width="100">削除!!</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined @click="showDelDlg = false" width="100">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- =============================== -->
    </v-container>
</template>

<script>
export default {
    name: "NotificationConfigs",
    //#######################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            user_id: 0,
            deviceOptions: [],
            dbUser: { id: "", name: "" },
            dbNotificationConfigs: [],
            isLoading: false,
            // headers: [
            //     { text: "デバイス名", value: "device_name" },
            //     { text: "通知項目", value: "alert_name" },
            //     { text: "上限/下限", value: "upper_lower_name" },
            //     { text: "再通知(分)", value: "silence_minutes" },
            //     { text: "メモ", value: "memo" },
            //     { text: "前回通知日時", value: "sent_at" },
            // ],
            alertOptions: [
                { value: "water", text: "水温" },
                { value: "temp", text: "気温" },
                { value: "solar", text: "日射量" },
                { value: "oxygen", text: "溶存酸素" },
                { value: "salinity", text: "塩分濃度" },
                //{ value: "current", text: "流速" },
                //{ value: "turbidity", text: "濁度" },
                { value: "err_serial", text: "シリアル通信エラー" },
                { value: "err_battery_low", text: "バッテリー低下" },
                { value: "err_feed_motor", text: "繰出モータエラー" },
                { value: "err_sprinkle_motor", text: "飛散モータエラー" },
                { value: "err_sensor1", text: "自発センサー1エラー" },
                { value: "err_sensor2", text: "自発センサー2エラー" },
                //{ value: "modified", text: "アライブ間隔(時間)" },
            ],
            silenceOptions: [
                { value: 1, text: "1分" },
                { value: 2, text: "2分" },
                { value: 3, text: "3分" },
                { value: 5, text: "5分" },
                { value: 10, text: "10分" },
                { value: 20, text: "20分" },
                { value: 30, text: "30分" },
                { value: 60, text: "1時間" },
                { value: 120, text: "2時間" },
                { value: 240, text: "4時間" },
                { value: 480, text: "8時間" },
                { value: 720, text: "12時間" },
                { value: 1440, text: "24時間" },
            ],
            upperLowerOptions: [
                { value: "upper", text: "上限設定" },
                { value: "lower", text: "下限設定" },
            ],
            //-------------------------
            showEditDlg: false,
            showDelDlg: false,
            editedIndex: -1,
            editedItem: {
                id: 0,
                user_id: "",
                device_id: "",
                alert_fld: "",
                upper_lower: "",
                limit_val: "",
                silence_minutes: "",
                memo: "",
                modified: "",
            },
            //-------------------------
            rules: {
                //required: value => !!value,
                required: (value) => !!value || "必須項目です",
                //email: value => /.+@.+\\..+/.test(value) || 'メールアドレスの形式が正しくありません',
                //tel: value => /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/.test(value.replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, ''))|| '電話番号の形式が正しくありません',
                //max: value => (value && value.length <= 100) || '100文字以下で入力してください',
            },
        };
    },
    //#######################################################
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.user_id = this.myInfo.id;
        await this.axiosGetUsers();
        await this.axiosGetDevices();
        await this.getNotificationConfigs();
        //----------------------------
        window.scrollTo(0, 0);
    },
    //#######################################################
    methods: {
        //====================================================
        async axiosGetUsers() {
            await this.axios({
                method: "GET",
                url: "/web/api/users",
                params: {
                    id: this.user_id,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                if (response.data.json[0]) this.dbUser = response.data.json[0];
            });
        },
        //====================================================
        async axiosGetDevices() {
            //----------------------------------------------
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: {
                    //site_id: this.myInfo.id,
                    "_order[name]": "asc",
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevices = response.data.json;
                //--------------------------
                // 選択用Options
                this.deviceOptions = [];
                for (let i in this.dbDevices) {
                    this.deviceOptions.push({
                        value: this.dbDevices[i].id,
                        text: this.dbDevices[i].name,
                    });
                }
                //--------------------------
            });
        },
        //====================================================
        async getNotificationConfigs() {
            await this.axios({
                method: "GET",
                url: "/web/api/notification_configs",
                params: { user_id: this.user_id },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbNotificationConfigs = response.data.json;
                for (let i in this.dbNotificationConfigs) {
                    let device_id = this.dbNotificationConfigs[i].device_id;
                    this.dbNotificationConfigs[i]["device_name"] = this.deviceName(device_id);
                }
                for (let i in this.dbNotificationConfigs) {
                    let fld = this.dbNotificationConfigs[i].alert_fld;
                    this.dbNotificationConfigs[i]["alert_name"] = this.alertName(fld);
                }
                for (let i in this.dbNotificationConfigs) {
                    let val = this.dbNotificationConfigs[i].sent_at;
                    if (val) this.dbNotificationConfigs[i]["sent_at"] = this.$moment(val).format("YYYY-MM-DD HH:mm");
                }
            });
        },
        //====================================================
        silenceText(minutes) {
            let ret = "";
            for (let obj of this.silenceOptions) {
                if (obj.value == minutes) ret = obj.text;
            }
            return ret;
        },
        //====================================================
        deviceName(device_id) {
            let device_name = "";
            for (let i in this.dbDevices) {
                if (device_id == this.dbDevices[i].id) device_name = this.dbDevices[i].name;
            }
            return device_name;
        },
        //====================================================
        alertName(fld) {
            let ret = "";
            for (let i in this.alertOptions) {
                let code = this.alertOptions[i].value;
                if (fld == code) ret = this.alertOptions[i].text;
            }
            return ret;
        },
        //====================================================
        editItemDialog(item) {
            if (!item) {
                this.editedIndex = -1;
                this.editedItem = {
                    id: 0,
                    site_id: this.dbUser.site_id,
                    user_id: this.dbUser.id,
                    user_name: this.dbUser.name,
                    device_id: "",
                    device_name: "",
                    alert_fld: "",
                    upper_lower: "",
                    limit_val: "",
                    silence_minutes: "",
                    memo: "",
                    modified: "",
                };
            } else {
                this.editedIndex = this.dbNotificationConfigs.indexOf(item);
                this.editedItem = Object.assign({}, item);
            }
            this.showEditDlg = true;
        },
        //====================================================
        async submitItem(item) {
            let ErrCount = 0;
            if (!item.user_id) ErrCount++;
            if (!item.device_id) ErrCount++;
            if (!item.alert_fld.trim()) ErrCount++;
            if (!item.silence_minutes) ErrCount++;
            if (["water", "temp", "oxygen", "solar", "salinity", "current", "turbidity"].includes(item.alert_fld)) {
                if (!item.upper_lower) ErrCount++;
                if (!item.limit_val) ErrCount++;
            }
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            if (!["water", "temp", "oxygen", "solar", "salinity", "current", "turbidity"].includes(item.alert_fld)) {
                item.upper_lower = "upper";
                item.limit_val = 1; // モータエラーや通信エラーは、[0]or[1]なので上限1とする。
            }
            //-----------------------------------
            item.limit_val = Math.floor(item.limit_val * 10) / 10; // 小数点第1位までで切り捨て
            if (item.limit_val > 9999999.9) item.limit_val = 9999999.9; //DBが、「double(9,2)」のため最大値制限
            if (item.limit_val < -9999999.9) item.limit_val = -9999999.9; //DBが、「double(9,2)」のため最大値制限
            //-----------------------------------
            const axiosData = {
                site_id: item.site_id,
                user_id: item.user_id,
                user_name: item.user_name,
                device_id: item.device_id,
                device_name: this.deviceName(item.device_id),
                alert_fld: item.alert_fld.trim(),
                upper_lower: item.upper_lower,
                limit_val: item.limit_val,
                silence_minutes: item.silence_minutes,
                memo: item.memo.trim(),
                modified: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
                sent_at: null,
            };
            //-----------------------------------
            let restMethod = "POST";
            let restUrl = "/web/api/notification_configs";
            if (item.id > 0) restMethod = "PUT";
            if (item.id > 0) restUrl = restUrl + "/" + item.id;
            //-----------------------------------
            await this.axios({
                method: restMethod,
                url: restUrl,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            }).then((response) => {
                if (response.data.json) {
                    self.console.log(response.data.json);
                    this.showEditDlg = false;
                    this.getNotificationConfigs();
                }
            });
        },
        //====================================================
        deleteItemConfirmDialog(item) {
            this.editedIndex = this.dbNotificationConfigs.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showDelDlg = true;
        },
        //====================================================
        async submitDeleteItem(item) {
            this.showDelDlg = false;
            this.showEditDlg = false;
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 1000));
            //-------------------------
            const PrimaryKey = item.id;
            await this.axios({
                method: "DELETE",
                url: "/web/api/notification_configs/" + PrimaryKey,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(() => {
                this.getNotificationConfigs();
            });
            this.isLoading = false;
        },
        //====================================================
    },
    //#######################################################
};
</script>
